import { LOCALE_CHANGED } from '../../constants'

export { default as getTexts } from '../../store/localizer'
export { default as Tooltip } from '../../containers/Tooltip'

export const constants = {
    LOCALE_CHANGED,
}



// WEBPACK FOOTER //
// ./src/features/Clock/imports.js